import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'

export const useConsentManualConfigs = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account, isFetching } = useGetAccountQuery({ accountId }, { refetchOnMountOrArgChange: true })

  const complianceConfig = account?.data.effectiveConfig.complianceConfig
  const userConsentManualConfigs = complianceConfig?.userConsentManualConfigs

  const evidenceUpload = userConsentManualConfigs?.evidenceUpload ?? null
  const commentUpload = userConsentManualConfigs?.commentUpload ?? null
  const userConsentManualOverride = complianceConfig?.userConsentManualOverride ?? false
  const userConsentTrackingEnabled = complianceConfig?.userConsentTrackingEnabled ?? false
  const consentWarningText = userConsentManualConfigs?.consentWarningText ?? null
  const inPersonComplianceMessage = complianceConfig?.inPersonComplianceMessage ?? null

  return {
    evidenceUpload,
    commentUpload,
    userConsentManualOverride,
    userConsentTrackingEnabled,
    consentWarningText,
    inPersonComplianceMessage,
    isFetching,
  }
}
